export enum EColumnsHeader {
  code = 'code',
  name = 'name',
  cnpj = 'cnpj',
  location_group_name = 'location_group_name',
  actions = 'actions',
  granted_days_required = 'granted_days_required',
  short_id = 'short_id',
  version_type = 'version_type',
  created_at = 'created_at',
  priority = 'priority',
  category_name = 'category_name',
  description = 'description',
  role_name = 'role_name',
  client_id = 'client_id',
  team = 'team',
}
